export const content = {
  emptyStateMessage: "No categories available",
};
